<template>
  <div class="container-fluid">
    <div class="card-header card-custom-brown" slot="card_title">
      <i class="fas fa-cubes "></i> Gestion des devis
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border my-3">
            <h3 class="box-title">
              <i class="fa fa-list-alt"></i> Mes devis
            </h3>
          </div>
            <Tableau ref="datatable"></Tableau>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    /* eslint-disable */
    import Tableau from "./components/MyCotationDevisTableau";

    export default {
        name: "Devis",
        data: function() {
            return {
                title: "Mes devis - Liste",
            };
        },
        metaInfo(){
            return {
                title: this.title,
                titleTemplate: this.titleApp + ' | %s',
            }
        },
        components: {
            Tableau,
        },
        methods: {

        },
    };
</script>

<style scoped></style>
